import { createStore, applyMiddleware, compose } from 'redux';
import { fromJS } from 'immutable';
import createSagaMiddleware from 'redux-saga';

import { rootReducer } from './reducers';
import { runSagas } from './sagas';

const sagaMiddleware = createSagaMiddleware();

function configureStore(initialState = {}) {
  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  /* eslint-enable */

  const store = createStore(
    rootReducer,
    fromJS(initialState),
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );

  runSagas(sagaMiddleware);

  return store;
}
export const store = configureStore({})
